import {
  FileAudio,
  Gauge,
  Mic,
  PhoneCall,
  PieChart,
  Rocket,
  ShieldCheck,
  Sparkles,
  Users,
  Workflow,
  type LucideIcon,
} from 'lucide-react'

/**
 * Explicit map rather than a dynamic lucide import — keeps the bundle to the
 * icons actually used and makes content.ts icon names type-checkable.
 */
export const icons = {
  FileAudio,
  Gauge,
  Mic,
  PhoneCall,
  PieChart,
  Rocket,
  ShieldCheck,
  Sparkles,
  Users,
  Workflow,
} satisfies Record<string, LucideIcon>

export type IconName = keyof typeof icons
